module.exports = __webpack_public_path__ + "img/00045.fd50cda9.webp";